export default __webpack_public_path__ + "static/media/skovstykket-floorplans-apartment-4-10.eb8273ea.jpg";